import { render, staticRenderFns } from "./AddDeclaration.vue?vue&type=template&id=8966e330"
import script from "./AddDeclaration.vue?vue&type=script&lang=js"
export * from "./AddDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports